module.exports = __webpack_public_path__ + "static/img/A9.23371509.jpg";